<div class="list-row">
  <div
    class="row customer"
    [ngClass]="customer.deactivated && 'deactivated'"
    (click)="onRowClick()"
    >
    <div class="colw colw-20 name">
      {{ customer.name.toLowerCase() }}
    </div>
    <div class="colw colw-20">
      {{ customer.ccid }}
    </div>
    <div class="colw colw-20">
      @for (consent of consents; track consent) {
        <div>
          @if (consent.channel_type === 'sms') {
            <span>{{
              formatPhoneNumber(consent.channel_addr)
            }}</span>
          }
        </div>
      }
    </div>
    <div class="colw colw-15">
      {{ customer.product_group_id }}
    </div>
    <div class="colw colw-10 text-right">
      <div class="icon-container text-right">
        @if (customerCanReceiveMessage()) {
          <i
            class="fa fa-paper-plane action-icon"
            id="send_journey"
            (click)="launchJourney(customer)"
            title="Send Experience"
            i18n="Button for sending an experience"
            matTooltip="Send Experience"
            matTooltipPosition="above"
            matTooltipClass="actions-tooltip-style"
          ></i>
        }
        @if (
          permissionService.checkPermissions(permissions.roc_customer_view)
          ) {
          <i
            class="fa fa-memo-circle-info action-icon"
            (click)="goToCustomerDetails(customer.ccid)"
            title="Customer Details"
            i18n="Button for viewing customer details"
            matTooltip="Customer Details"
            matTooltipPosition="above"
            matTooltipClass="actions-tooltip-style"
          ></i>
        }
      </div>
    </div>
    <div class="colw colw-15 expand-column">
      @if (!displayDetails) {
        <i class="fa fa-caret-right expand-collapse"></i>
      }
      @if (displayDetails) {
        <i class="fa fa-caret-down expand-collapse"></i>
      }
    </div>
  </div>
  @if (displayDetails) {
    <div class="row detail customer-details-container">
      @if (isLoadingDetails) {
        <app-spinner></app-spinner>
      }
      @if (!isLoadingDetails) {
        @if (!canViewPhoneMgmtEdit) {
          <div class="customer-details">
            @if (
              permissionService.checkPermissions(permissions.roc_customer_view)
              ) {
              <button
                class="btn btn-sm"
                (click)="goToCustomerDetails(customer.ccid)"
                >
                Customer Details
                <span i18n="Button for viewing customer details"></span>
                <span class="icon icon-right"><i class="fa fa-"></i></span>
              </button>
            }
          </div>
          @for (consent of consents; track consent; let i = $index) {
            <div class="channels">
              @if (i == 0) {
                <div class="channel">
                  <span>Channel</span><span>Current consent type</span>
                </div>
              }
              @if (consent.channel_type === 'sms') {
                <div class="channel">
                  <span>{{ consent.channel_addr | phoneNumber }}</span>
                  <span> {{ consent.consent_type }}</span>
                  @if (canEditConsent && consent.consent_type !== 'stop') {
                    <button
                      class="btn btn-sm btn-warning"
                      id="stop_consent"
                      (click)="confirmStopConsent(customer, consent, $event)"
                      >
                      <span i18n="Button for stopping consent">Stop Consent</span>
                        <span class="icon icon-right"
                          ><i class="fa fa-hand-paper-o"></i
                        ></span>
                      </button>
                    }
                  </div>
                }
              </div>
            }
          }
          @if (canViewPhoneMgmtEdit) {
            @if (!isLoadingDetails) {
              <div class="phone-management-edit col-12">
                <app-customer-consent-list
                  [customerConsents]="consents"
            (phoneNumberAdded)="
              onCustomerChannelAdd(customer.id, customer.ccid, $event)
            "
            (phoneNumberDeleted)="
              onCustomerChannelDelete(customer.id, customer.ccid, $event)
            "
            (consentUpdated)="
              onCustomerConsentChange(customer.id, customer.ccid, $event)
            "
                ></app-customer-consent-list>
              </div>
            }
          }
        }
      </div>
    }
  </div>

  <message-dialog
    #stopConsentDialog
    (affirm)="stopConsent($event)"
    [showCancel]="true"
  ></message-dialog>
  <message-dialog
    #serverErrorDialog
    (affirm)="serverErrorDialog.close()"
  ></message-dialog>
